import {ImageRemoveBg} from "../../components/my_tools/ai_remover/imageRemoveBg";

interface IAIRemover{
    globalTextColor: string;
    isLight: boolean;
}
export const AIRemover: React.FC<IAIRemover> = ({globalTextColor, isLight}) => {
    return (
        <div className={`text-[${globalTextColor}]`}>
            <ImageRemoveBg isLight={isLight} />
        </div>
    );
}
